import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownWideShort, faCheck } from '@fortawesome/free-solid-svg-icons';

export default function SortByDropdown({
  options,
  value,
  onChange,
}) {
  const [optionsOpen, toggleOptions] = useState(false);

  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (buttonRef.current && optionsOpen && !buttonRef.current.contains(e.target)) {
        toggleOptions(false);
      }
    };

    // Set up event listener for clicks outside of the sortby which will need to close the dropdown
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [optionsOpen]);

  return (
    <div className="SortByDropdown">
      <button
        ref={buttonRef}
        className="SortByDropdown__button"
        onClick={() => { toggleOptions(!optionsOpen); }}
      >
        <FontAwesomeIcon icon={faArrowDownWideShort} />
        <label>
          <FormattedMessage id="sort-by-dropdown.label" defaultMessage="Sort by" />
        </label>
      </button>

      {optionsOpen &&
        <div className="SortByDropdown__options">
          {options.map(option =>
            <button
              key={option.name}
              className={classNames('SortByDropdown__options__option', { 'SortByDropdown__options__option--active': option.value === value })}
              onClick={() => { onChange(option.value); }}
            >
              <div className="SortByDropdown__options__option__icon">
                {option.value === value &&
                  <FontAwesomeIcon icon={faCheck} />
                }
              </div>
              {option.name}
            </button>,
          )}
        </div>
      }
    </div>
  );
}

SortByDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  })),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

SortByDropdown.defaultProps = {
  options: [],
  value: '',
};
